import React from "react";

const Spinner = ({ styles, text }) => (
  <div className="transient-loader" style={styles}>
    <div />
    <div className="innerContainer">
      <div className="spinning" />
      <div style={{ marginTop: 10 }}>{text}</div>
    </div>
  </div>
);

export default Spinner;
